import React, { useEffect, useState } from "react";
import { Button, TextField, Autocomplete } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import {
  doc,
  serverTimestamp,
  updateDoc,
  getDocs,
  collection,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";

function EditPsychoEdNote(props) {
  const { currentUser } = useAuth();
  const [noteText, setNoteText] = useState(
    props.note || props.noteContent || ""
  );
  const [subject, setSubject] = useState(props.subject || "");
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [effectiveDateTime, setEffectiveDateTime] = useState(
    props.effectiveDateTime?.toDate
      ? props.effectiveDateTime.toDate()
      : props.effectiveDate || new Date()
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(
          query(collection(db, "psychoEdSubjects"), orderBy("subject", "asc"))
        );
        const options = [];
        snap.forEach((d) => {
          const s = d.data()?.subject;
          if (s) options.push(s);
        });
        setSubjectOptions(Array.from(new Set(options)));
      } catch (e) {
        console.warn("PsychoEd subjects fetch error:", e);
      }
    })();
  }, []);

  const handleUpdate = async () => {
    if (!subject) {
      showCustomToast("Subject is required.", "error");
      return;
    }
    if (!noteText || !effectiveDateTime) {
      showCustomToast(
        "Some mandatory fields are empty. Please check.",
        "error"
      );
      return;
    }
    setIsLoading(true);
    try {
      const noteRef = doc(db, "notes", props.noteId);
      await updateDoc(noteRef, {
        noteContent: noteText,
        subject,
        effectiveDateTime,
        updateAt: serverTimestamp(),
        doneBy: currentUser?.displayName || currentUser?.email || "Unknown",
      });
      // also store subject for future autocomplete
      try {
        await updateDoc(
          doc(db, "psychoEdSubjects", `${subject.toLowerCase()}-${Date.now()}`),
          {
            subject,
            createdAt: serverTimestamp(),
            createdBy: currentUser?.uid || null,
          }
        );
      } catch (e) {
        // ignore
      }
      showCustomToast("Psycho-Ed note updated successfully.", "success");
      setIsLoading(false);
      props.closemodal();
    } catch (e) {
      console.error("Error updating Psycho-Ed note:", e);
      showCustomToast("Error when updating note", "error");
      setIsLoading(false);
    }
  };

  return (
    <div className="inputAndLabelModalContainerTitle2">
      <div className="line1-modal">
        <div className="modal-title">Edit Psycho-Ed Note</div>
        <CloseIcon
          style={{
            marginRight: "16px",
            color: "rgb(214, 213, 213)",
            cursor: "pointer",
          }}
          onClick={props.closemodal}
        />
      </div>

      <div className="line2-column-modal">
        <div className="label-textfield">Subject (required)</div>
        <div style={{ backgroundColor: "lightpink", width: "95%" }}>
          <Autocomplete
            freeSolo
            options={subjectOptions}
            value={subject}
            onInputChange={(_, val) => setSubject(val)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Type or select a subject"
                size="small"
                sx={{
                  backgroundColor: "#f2eeef",
                  borderRadius: "5px",
                }}
                fullWidth
              />
            )}
          />
        </div>
      </div>

      <div className="line2-column-modal" style={{ marginTop: 12 }}>
        <div className="label-textfield">Note content</div>
        <TextField
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          style={{
            width: "95%",
            borderRadius: "5px",
            backgroundColor: "#f2eeef",
          }}
          placeholder="Type Psycho-Ed note here"
          multiline
          rows={12}
        />
      </div>
      <div
        className="line3-modal-nopad"
        style={{ paddingLeft: "20px", marginTop: 10 }}
      >
        <DatePickerWithTimeComponent
          title="Effective date and time"
          value={effectiveDateTime}
          onChange={setEffectiveDateTime}
        />
      </div>

      <div className="line4-modal">
        <Button
          variant="contained"
          style={{ backgroundColor: "white", color: "black" }}
          onClick={props.closemodal}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          style={
            isLoading
              ? { backgroundColor: "red", color: "white", marginLeft: "15px" }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          onClick={handleUpdate}
        >
          {isLoading ? "UPDATING NOTE..." : "UPDATE NOTE"}
        </Button>
      </div>
    </div>
  );
}

export default EditPsychoEdNote;
